import EleDynamicForm from './Parser.vue'
import * as renderComponent from './render/render'

const install = (Vue) => {
    Vue.component(EleDynamicForm.name, EleDynamicForm)
}

if (window && window.Vue) {   //通过`script`标签引入的情况，在组件内部完成组件注册。
    window.Vue.use(install)
}

export default install
export const render = renderComponent

